import Vue from 'vue'
// 引入ValidationProvider用于实现表单校验
import {ValidationProvider,extend,ValidationObserver} from 'vee-validate'
import {required} from 'vee-validate/dist/rules'
import {phoneReg,codeReg,passwordReg} from './reg'
// 将ValidationProvider注册为全局组件
Vue.component('ValidationProvider',ValidationProvider)
Vue.component('ValidationObserver',ValidationObserver)

// 校验手机号的规则
extend('shouji',{
  validate(value){
    return phoneReg.test(value)
  },
  message:'手机号格式不合法'
})

extend('code',{
  validate(value){
    return codeReg.test(value)
  },
  message:'验证码必须为6位纯数字'
})

extend('mima',{
  validate(value){
    return passwordReg.test(value)
  },
  message:'密码格式为：6~21位的 数字、字母、下划线'
})

extend('queren',{
  validate(value,params){
    return value === params[0]
  },
  message:'确认密码必须和密码一致'
})

extend('agree',{
  validate: value => value,
  message:'请同意协议',
})

extend('bixu',{
  ...required,
  message:'{_field_}不能为空'
})